define('mixins/general/query-params-mixin',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils'
    // views
], function(
    // Libs
    _, Backbone, Mustache, U
    // views
) {

    return {

        /**
         * https://github.com/backbone-paginator/backbone.paginator/blob/93294f4865055245e5207008c6bd35be661c5c69/lib/backbone.paginator.js#L79
         */
        queryStringToParams: function(qs) {
            var keyValue, key, value, ls, params = {},
                decode = decodeURIComponent;
            var keyValueArray = qs.split('&');
            for (var i = 0, length = keyValueArray.length; i < length; i++) {
                var param = keyValueArray[i];
                keyValue = param.split('=');
                value = keyValue[1];
                if (value == null) value = true;
                key = decode(keyValue[0]);
                value = decode(value);
                ls = params[key];
                if (_.isArray(ls)) ls.push(value);
                else if (ls) params[key] = [ls, value];
                else params[key] = value;
            }
            return params;
        },

        /**
         * Map the query params to the data object used by the underlying ajax lib
         * to construct the query string.
         * @param  {Object} data to extend
         * @return {Object}   of all the data to be inserted as a querystring.
         */

        getQueryStringData: function(data) {
            data = data || {};
            var state = this.state;

            _.each(this.queryParams, function(param, queryParamKey) {
                if (_.isString(param)) {
                    var key = queryParamKey;
                    queryParamKey = param;
                    param = state[key];
                } else if (_.isFunction(param)) param = param.call(this);
                if (param != null && _.isUndefined(data[queryParamKey])) {
                    data[queryParamKey] = param;
                }
            }, this);
            return data;
        },

    };
});

